/**
 * LoopNest Media Provider — User Upload
 * Handles user-owned media files.
 * License: User-owned (user is responsible for their uploads)
 */

import { BaseMediaProvider, LICENSE_TYPES, createMediaItem } from './baseProvider';

export class UserUploadProvider extends BaseMediaProvider {
  constructor() {
    super({
      id: 'user-upload',
      label: 'User Upload',
      license: LICENSE_TYPES?.USER_OWNED,
      requiresAttribution: false,
      enabled: true,
    });
  }

  /**
   * Create a MediaItem from a File object
   */
  fromFile(file) {
    if (!file) return null;
    const url = URL.createObjectURL(file);
    return createMediaItem({
      id: `user-upload-${file?.name}-${Date.now()}`,
      url,
      previewUrl: url,
      alt: file?.name,
      author: 'User',
      providerId: this.id,
      license: this.license,
      requiresAttribution: false,
    });
  }

  async search() {
    // User uploads are not searchable — they are provided directly
    return [];
  }
}

export const userUploadProvider = new UserUploadProvider();
